import { Space, Typography } from 'antd';
import classNames from 'classnames';

import type { ColumnDataType } from '@app/pages/Analytics/FinancialResultsReport/types';
import { defineDynamicIcon } from '@app/pages/Analytics/utils';
import { divideAmount } from '@app/utils';

import type { TableColumnsType } from 'antd';

const { Text } = Typography;

export const COLUMNS: TableColumnsType<ColumnDataType> = [
  {
    title: 'Название',
    dataIndex: 'label',
    key: 'label',
    render: (_, record) => <div className="columns__name">{record.label}</div>,
  },
  {
    title: 'Сумма',
    dataIndex: 'amount',
    render: (value: number) => (
      <Text className="amount-cell">{divideAmount(value)}</Text>
    ),
  },
  {
    title: 'Доля от фактической реализации',
    dataIndex: 'percentageIncome',
    render: (value: number) => (
      <Text>
        <Space size={4}>{`${divideAmount(value)}%`}</Space>
      </Text>
    ),
  },
  {
    title: '% роста по предыдущему месяцу',
    dataIndex: 'percentageGrowthPrevMonth',
    render: (value: number, { isExpense }) => (
      <Text
        className={classNames(
          'report-table-digits',
          'columns__increasing_last-month',
          {
            positive: isExpense ? value < 0 : value > 0,
            negative: isExpense ? value > 0 : value < 0,
          }
        )}
      >
        <Space size={4}>
          {`${divideAmount(value)}%`}
          {defineDynamicIcon(value)}
        </Space>
      </Text>
    ),
  },
  {
    title: '% рост по месяцу предыдущего года',
    dataIndex: 'percentageGrowthPrevYear',
    render: (value: number, { isExpense }) => (
      <Text
        className={classNames(
          'report-table-digits',
          'columns__increasing_last-year',
          {
            positive: isExpense ? value < 0 : value > 0,
            negative: isExpense ? value > 0 : value < 0,
          }
        )}
      >
        <Space size={4}>
          {`${divideAmount(value)}%`}
          {defineDynamicIcon(value)}
        </Space>
      </Text>
    ),
  },
];
